<header class="details-header">
    <div class="detail-header__title-wrapper">
      <h1 class="details-header__title ci-heading-h1-s-bold">
        {{ name()?.[translate.currentLang] }}
      </h1>
      
      <!-- TODO: REFACTOR -->
      @if (duration()) {
        <ci-suggestion-chip-outline
          class="details-header__duration-chip"
          icon-name="duracion"
          selected
        >
          <span slot="label">
            @if (duration().hours){
              {{ duration().hours > 1
                  ? duration().hours + ' ' + ('horas' | translate)
                  : '1 ' + ('hora' | translate)
              }} 
            }
            @if (duration().minutes){
              {{ duration().minutes > 1
                  ? duration().minutes + ' ' + ('minutos' | translate)
                  : '1 ' + ('minuto' | translate)
              }} 
            }
          </span>
        </ci-suggestion-chip-outline>
      }
    </div>

    @if(accessibilityList() && accessibilityList().length > 0) {
      <section 
        #swiper
        class="details-header__accesibility"
      >
        <ul class="accessibility__items swiper-wrapper">
          @for (item of accessibilityList(); track item){
              @if(item.description?.[translate.currentLang]){
                  <li 
                    class="accessibility__item swiper-slide"
                    matTooltip="{{ item.description[translate.currentLang] }}"
                  >
                    <img 
                      draggable="false" 
                      [src]="item.icon"
                      (error)="toolsService.onImageError($event)" 
                    />
                    <!--<span> {{  item.description[translate.currentLang] }}</span>            -->
                  </li>
              }
          }
      </ul>
      </section>
    }

    <details-button (click)="handleClick()" [text]="'Llévatelo a tu móvil'" />
</header>